export function createSelectRender(enumValue, enumRenders) {
    return {
        value: enumValue,
        label: enumRenders[enumValue]
    }
}
